<template>
  <div>
    <Header />

    <section class="filters-section">
      <div class="container">
        <!-- Botón para mostrar/ocultar el panel de filtros -->
        <div class="filter-trigger">
          <button class="filters-toggle-btn" @click="toggleFilters">
            <span>{{ showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros' }}</span>
            <i class="lni" :class="showFilters ? 'lni-chevron-up' : 'lni-chevron-down'"></i>
          </button>
        </div>

        <!-- El panel que se despliega con los filtros -->
        <div class="filters-panel" :class="{ 'is-open': showFilters }">
          <div class="filters-content">
            <!-- Filtro: Nombre del Producto -->
            <div class="filter-group">
              <h4 class="filter-title">Buscar por nombre</h4>
              <input type="text" v-model="filtros.nombre" @input="handleFilterChange"
                placeholder="Escribe el producto..." class="search-input" />
            </div>

            <!-- Filtro: Modelo de Batería -->
            <div class="filter-group">
              <h4 class="filter-title">Buscar por modelo</h4>
              <input type="text" v-model="filtros.modelo" @input="handleFilterChange" placeholder="Escribe el modelo..."
                class="search-input" />
            </div>

            <!-- Filtro: Marca -->
            <div class="filter-group">
              <h4 class="filter-title">Buscar por marca</h4>
              <input type="text" v-model="filtros.marca" @input="handleFilterChange" placeholder="Escribe la marca..."
                class="search-input" />
            </div>

            <!-- Filtro: Rango de Precio -->
            <div class="filter-group">
              <h4 class="filter-title">Rango de Precio</h4>
              <div class="price-range-display">
                <span>${{ formatCurrency(filtros.precio[0]) }}</span> –
                <span v-if="filtros.precio[1] === 100000">{{ formatCurrency(filtros.precio[1]) }}+</span>
                <span v-else>{{ formatCurrency(filtros.precio[1]) }}</span>
              </div>
              <div class="price-range-container">
                <Slider v-model="filtros.precio" :min="0" :max="100000" :step="10" :tooltip-formatter="priceFormatter"
                  range class="slider" />
              </div>
            </div>
          </div>
          <!-- Botón de aplicar centrado -->
          <div class="apply-filters-footer">
            <button @click="filtrarProductos" class="go-button">Aplicar Filtros</button>
          </div>
        </div>
      </div>
    </section>


    <!-- Start Main Content Area -->
    <div class="main-content">
      <!-- Start Trending Product Area -->
      <section class="trending-product section">
        <div class="container">
          <div class="row">
            <!-- Mostrar mensaje de cargando -->
            <div v-if="isLoading" class="loading-overlay">
              <div class="spinner"></div>
            </div>

            <!-- Mostrar mensaje de no resultados -->
            <div v-else-if="productosFiltrados.length === 0" class="no-results-message">
              No hay resultados relacionados con esta busqueda
            </div>

            <div class="row five-cols">
              <div class="col custom-col" v-for="producto in productosFiltrados" :key="producto.id">
                <!-- Start Single Product -->
                <div class="single-product" @click="verDetallesProducto(producto.id)">
                  <div class="product-image">
                    <!-- Controles del carrito -->
                    <div class="cart-controls" @click.stop>
                      <template v-if="isProductInCart(producto.id)">
                        <!-- <div class="quantity-controls">
                          <button @click.stop="decrementQuantity(getCartItemId(producto.id))" :disabled="isProcessing"
                            class="quantity-btn">
                            <i class="lni lni-minus"></i>
                          </button>
                          <span class="quantity">{{ getCartQuantity(producto.id) }}</span>
                          <button @click.stop="incrementQuantity(getCartItemId(producto.id))" :disabled="isProcessing"
                            class="quantity-btn">
                            <i class="lni lni-plus"></i>
                          </button>
                        </div> -->
                        <button v-if="isProductInCart(producto.id)" class="cart-button added" disabled
                          title="Agregado al carrito">
                          <div class="icon-wrapper">
                            <i class="lni lni-cart"></i>
                            <i class="lni lni-checkmark-circle check-icon"></i>
                          </div>
                        </button>
                      </template>
                      <template v-else>
                        <button @click.stop="agregarAlCarrito(producto.id)" class="cart-button"
                          :disabled="isProcessing || !isLoggedIn">
                          <i class="lni lni-cart"></i>
                        </button>
                      </template>
                    </div>
                    <!-- Mostrar la imagen de portada o una imagen por defecto -->
                    <img :src="getImagenPortada(producto.imagenes)" alt="#" class="product-image-size" />

                    <!-- Overlay de Confirmación -->
                    <div v-if="animationProductId === producto.id" class="product-added-overlay">
                      <div class="overlay-content">
                        <i class="lni lni-checkmark"></i>
                        <span>Producto agregado</span>
                      </div>
                    </div>

                    <!-- Botón Agregar al Carrito -->
                    <div class="button">
                      <div v-if="animationProductId !== producto.id">
                        <!-- <button
                        @click="agregarAlCarrito(producto.id)"
                        class="btn"
                        :disabled="isProcessing"
                      >
                        <i class="lni lni-cart"></i> Agregar
                      </button> -->

                        <!-- <button @click="verDetallesProducto(producto.id)" class="btn btn-outline-primary w-100">
                        <i class="lni lni-angle-double-right"></i> Ver
                      </button> -->
                      </div>
                    </div>
                  </div>
                  <div class="product-info">
                    <!-- <span class="category">{{ toTitleCase(producto.repuesto.nombre) }}</span> -->
                    <h4 class="title">
                      <a @click="verDetallesProducto(producto.id)">{{ toTitleCase(producto.repuesto.nombre) }}</a>
                    </h4>
                    <p class="card-text text-secondary small mb-2" style="font-size: 1.1em">
                      <!-- {{ producto.marca.nombre }} - {{ producto.modelo.nombre }} -->
                    </p>
                    <div class="price" :class="{ blurred: !isLoggedIn }">
                      <span>{{ formatCurrency(producto.precioVenta) }}</span>
                    </div>
                  </div>
                </div>
                <!-- End Single Product -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Trending Product Area -->
    </div>
    <!-- End Main Content Area -->

    <!-- ========================= scroll-top ========================= -->
    <a href="#" class="scroll-top">
      <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Swal from "sweetalert2";
import EventBus from "@/EventBus";
import { CarritoService } from "@/services/CarritoService";
import { ProductoService } from "@/services/ProductoService";
import Slider from "vue-slider-component";
import { useRouter } from "vue-router";
import "vue-slider-component/theme/default.css"; // Para los estilos predeterminados
import { config } from "@/config";
import { formatCurrency } from "@/utils/formatPrice";

export default {
  name: "HomePage",
  components: {
    Header,
    Slider,
  },
  data() {
    return {
      filtros: {
        nombre: "",
        modelo: "",
        marca: "",
        precio: [0, 100000],
      },
      searchTimeout: null,
      showFilters: false,
      isLoading: false,
      isProcessing: false,
      productos: [],
      cartItems: [],
      productosFiltrados: [],
      animationProductId: null,
      marks: {
        0: "$0",
        10000: "$10000",
      },
    };
  },
  async mounted() {
    EventBus.on("cartUpdated", this.handleCartUpdate); // Registra el callback

    if (!this.$route.query.q) {
      // Verifica si no hay un parámetro de búsqueda en la URL
      this.getAllProductos(); // Solo carga todos los productos si no hay búsqueda
    }
  },
  computed: {
    isInCart() {
      return (productoId) => this.cartItems.some(item => item.productoID === productoId);
    },
    // Verificar si el usuario está logueado comprobando el token
    isLoggedIn() {
      const accessToken = localStorage.getItem("accessToken");
      return accessToken !== null; // Si el token existe, el usuario está logueado
    },
  },
  async mounted() {
    EventBus.on("cartUpdated", this.handleCartUpdate); // Registra el callback

    if (this.isLoggedIn) {
      await this.fetchCarritoUser(); // Solo carga el carrito si el usuario está logueado
    }
  },
  watch: {
    "$route.query.q": {
      handler(newQuery) {
        this.filtros.nombre = newQuery || ""; // Actualiza el texto de búsqueda
        this.filtrarProductos(); // Busca productos al cambiar la query
      },
      immediate: true, // Esto ejecuta el watcher inmediatamente al montarse
    },
  },
  methods: {
    handleCartUpdate() {
      this.fetchCarritoUser(); // Actualiza el carrito cuando el evento se emite
    },
    formatCurrency,
    toTitleCase(str) {
      if (!str) return ''; // Manejar casos donde str es null o undefined
      return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
      // O una versión más explícita:
      // return str.toLowerCase().split(' ').map(word => {
      //   return word.charAt(0).toUpperCase() + word.slice(1);
      // }).join(' ');
    },
    priceFormatter(val) {
      // Si el valor es el máximo, añade "+"
      if (val === 1000) {
        return `$${val}+`;
      }
      return `$${val}`; // Muestra el símbolo de dólar para los demás valores
    },
    getImagenPortada(imagenes) {
      const portada = imagenes.find((imagen) => imagen.portada);
      if (!portada) return require("@/assets/paquete.png");
      return portada.imagen.startsWith('http') ? portada.imagen : `${config.API_URL}${portada.imagen}`;
    },
    isValidToken() {
      const token = localStorage.getItem("accessToken");
      return token && token.split(".").length === 3;
    },
    async agregarAlCarrito(productoId) {
      let accessToken = localStorage.getItem("accessToken");

      if (!this.isValidToken()) {
        localStorage.removeItem("accessToken");
        accessToken = null;
      }

      if (!accessToken) {
        Swal.fire({
          title: "Necesitas iniciar sesión",
          text: "Para agregar productos al carrito, primero debes iniciar sesión.",
          icon: "warning",
          confirmButtonText: "Iniciar sesión",
          customClass: { confirmButton: "swal-button--confirm-custom" },
        }).then((result) => {
          if (result.isConfirmed) this.$router.push("/login");
        });
        return;
      }

      if (this.isProcessing) return;

      try {
        this.isProcessing = true;
        const response = await CarritoService.addDetalle({
          productoID: productoId,
          cantidad: 1,
        });

        if (response.exito) {
          this.animationProductId = productoId;
          setTimeout(() => {
            this.animationProductId = null;
            this.isProcessing = false;
          }, 1000);
          EventBus.emit("cartUpdated");
        } else {
          this.isProcessing = false;
          Swal.fire({
            title: "Error",
            text: `Error: ${response.errores}`,
            icon: "error",
          });
        }
      } catch (error) {
        this.isProcessing = false;
        console.error("Error al agregar el producto al carrito:", error);
        Swal.fire({
          title: "Error",
          text: "Error al agregar el producto al carrito",
          icon: "error",
        });
      }
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    handleFilterChange() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filtrarProductos();
      }, 500); // Esperar 500ms después de que el usuario deje de escribir
    },
    async filtrarProductos() {
      this.isLoading = true;
      this.showFilters = false;
      const filtros = {
        nombre: this.filtros.nombre,
        modelo: this.filtros.modelo,
        marca: this.filtros.marca,
        precioMinimo: this.filtros.precio[0] ?? 0,
        precioMaximo: this.filtros.precio[1] ?? 0,
      };
      try {
        const response = await ProductoService.getProductosFiltrados(filtros);
        if (response.exito) {
          if (response.datos && response.datos.length > 0) {
            this.productosFiltrados = response.datos;
            this.productos = response.datos;
          } else {
            // Si no hay productos que coincidan, vaciar la lista y mostrar el mensaje
            this.productosFiltrados = [];
            this.productos = [];
          }
        } else {
          console.error("Error en los filtros:", response.errores);
        }
      } catch (error) {
        console.error("Error al aplicar filtros:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllProductos() {
      this.isLoading = true;
      try {
        const allProducts = await ProductoService.getAllProductos();
        this.productos = allProducts.datos;
        this.productosFiltrados = allProducts.datos; // Inicia mostrando todos los productos
      } catch (error) {
        console.error("Error al cargar productos:", error);
      } finally {
        this.isLoading = false;
      }
    },
    verDetallesProducto(id) {
      // Redirigir a la página de detalles pasando el `id` como parámetro
      this.$router.push({ name: "ProductoDetalle", params: { id } });
    },


    handleCartUpdate() {
      this.fetchCarritoUser(); // Actualiza el carrito cuando el evento se emite
    },

    isProductInCart(productoId) {
      const exists = this.cartItems.some(item => item.productoID === productoId);
      return exists;
    },


    getCartItemId(productoId) {
      const item = this.cartItems.find(item => item.productoID === productoId);
      return item ? item.detalleCarritoID : null;
    },

    getCartQuantity(productoId) {
      const item = this.cartItems.find(item => item.productoID === productoId);
      return item ? item.cantidad : 0;
    },

    // Función para incrementar la cantidad de un ítem en el carrito
    async incrementQuantity(itemID) {
      const item = this.cartItems.find((i) => i.detalleCarritoID === itemID);
      if (item) {
        const newQuantity = item.cantidad + 1;
        try {
          const result = await CarritoService.updateDetalle(itemID, newQuantity);

          // Confirmar que la actualización fue exitosa antes de actualizar la UI
          if (result) {
            item.cantidad = newQuantity;
            this.fetchCarritoUser();
            EventBus.emit("cartUpdated");
          } else {
            console.error("Error al confirmar la actualización en el backend.");
          }
        } catch (error) {
          console.error("Error al actualizar la cantidad:", error);
          // Revertir el incremento en caso de error
          item.cantidad--;
        }
      }
    },

    // Función para decrementar la cantidad de un ítem en el carrito
    async decrementQuantity(itemID) {
      const item = this.cartItems.find((i) => i.detalleCarritoID === itemID);
      if (!item) return;

      if (item.cantidad === 1) {
        try {
          await this.removeItem(itemID);
          await this.fetchCarritoUser(); // Asegurar que se actualiza la UI
          EventBus.emit("cartUpdated");
        } catch (error) {
          console.error("Error al eliminar el producto:", error);
        }
      } else {
        try {
          const result = await CarritoService.updateDetalle(itemID, item.cantidad - 1);
          if (result) {
            item.cantidad--;
            await this.fetchCarritoUser();
          } else {
            console.error("Error al confirmar la actualización en el backend.");
          }
        } catch (error) {
          console.error("Error al actualizar la cantidad:", error);
        }
      }
    },



    // Función para actualizar la cantidad de un ítem en el carrito
    async updateQuantity(item) {
      try {
        const result = await CarritoService.updateDetalle(item.detalleCarritoID, item.cantidad);

        // Confirmar que la actualización fue exitosa
        if (result) {
          fetchCarritoUser();
          EventBus.emit("cartUpdated");
        }
      } catch (error) {
        console.error("Error al actualizar la cantidad:", error);
      }
    },

    async fetchCarritoUser() {
      try {
        const datos = await CarritoService.getCarritoUser(); // Llama al servicio

        // Verifica si 'datos' es nulo antes de acceder a 'detallesCarrito'
        if (!datos || !datos.detallesCarrito) {
          this.cartItems = []; // Inicializa con un carrito vacío en la UI
          return;
        }

        // Asigna los detalles del carrito si están disponibles
        this.cartItems = datos.detallesCarrito;
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error.message || "Error al obtener el carrito",
          icon: "error",
        });
      }
    },

    async removeItem(detalleCarritoID) {
      try {
        const response = await CarritoService.deleteDetalle(detalleCarritoID);

        console.log(response);
        // Verificar que la eliminación fue exitosa antes de actualizar el estado
        if (response) {
          this.cartItems = this.cartItems?.filter(
            (item) => item.detalleCarritoID !== detalleCarritoID
          ) || [];

          this.totalAmount = this.cartItems.reduce(
            (acc, item) => acc + (item.producto?.precioVenta ?? 0) * item.cantidad,
            0
          );
          EventBus.emit("cartUpdated");
        }
      } catch (error) {
        console.error("Error al eliminar ítem:", error);

        Swal.fire({
          title: "Error",
          text: "No se pudo eliminar el ítem.",
          icon: "error",
          customClass: {
            confirmButton: "swal-button--confirm-custom",
          },
        });
      }
    }
  },
};
</script>

<style scoped>
.no-results-message {
  display: flex;
  /* Flex para centrar el contenido */
  justify-content: center;
  align-items: center;
  height: 100%;
  /* Cambiar a 100% para ocupar todo el contenedor */
  font-size: 24px;
  /* Tamaño de fuente más grande */
  color: #888;
  /* Color gris */
  text-align: center;
  /* Centrar texto */
  font-weight: bold;
  /* Negrita para mayor énfasis */
  margin-top: 50px;
  /* Espacio superior para separar del resto */
  flex: 1;
  /* Permitir que el mensaje ocupe el espacio restante */
}

.product-image-size {
  width: 100%;
  height: 200px;
  object-fit: cover;
  position: relative;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.main-content {
  display: flex;
  gap: 20px;
}

.filters-section {
  background-color: #ffff;
}

.filter-trigger {
  text-align: left;
  /* Centra el botón */
  margin-bottom: 10px;
}

.filters-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background-color: #007bff;
  color: white;
  padding: 4px 13px;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.filters-toggle-btn:hover {
  background-color: #0056b3;
}

.filters-toggle-btn i {
  transition: transform 0.3s ease;
  /* Animación para el icono de flecha */
}

/* El panel que contiene los filtros */
.filters-panel {
  max-height: 0;
  /* Empieza colapsado */
  overflow: hidden;
  /* Oculta el contenido cuando está colapsado */
  transition: max-height 0.5s ease-in-out;
  /* Animación suave de despliegue */
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

/* Estado abierto del panel */
.filters-panel.is-open {
  max-height: 1000px;
  /* Un valor alto para permitir que el contenido se expanda */
}

/* Contenedor interno para el padding y la cuadrícula */
.filters-content {
  display: grid;
  /* Crea una cuadrícula responsive: 
     - Las columnas tendrán un mínimo de 250px.
     - Se ajustarán automáticamente para llenar el espacio.
     - Si no caben, pasarán a la siguiente fila.
  */
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  padding: 25px;
}

.filter-group {
  margin-bottom: 0;
  /* El gap de la cuadrícula ya proporciona separación */
}

.filter-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 500;
}

.apply-filters-footer {
  text-align: center;
  padding: 0 25px 25px 25px;
  /* Padding inferior y a los lados */
}

.go-button {
  background-color: #28a745;
  /* Color verde para la acción principal */
  color: white;
  padding: 12px 30px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 8px;
  width: auto;
  /* Ancho automático basado en el contenido */
  min-width: 200px;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.go-button:hover {
  background-color: #218838;
  transform: translateY(-2px);
}

h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

.search-input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 16px;
  transition: border-color 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
}

.single-product {
  background-color: #fff;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  min-width: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.single-product:hover {
  transform: translateY(-10px);
}

.btn {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db; /* azul */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Asegúrate de que el contenedor padre tenga un tamaño adecuado */
.trending-product {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  /* Permitir que el contenedor ocupe todo el espacio disponible */
}

.scroll-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s, transform 0.3s;
}

.scroll-top:hover {
  background-color: #0056b3;
  transform: translateY(-3px);
}

/* Overlay de confirmación */
.product-added-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  /* Fondo oscuro semitransparente */
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  z-index: 10;
  animation: fadeInOut 1s ease-in-out;
}

.overlay-content {
  text-align: center;
}

.overlay-content i {
  font-size: 40px;
  color: #4caf50;
  /* Color del icono de confirmación */
  display: block;
  margin-bottom: 10px;
  animation: bounce 1s;
  /* Animación de rebote */
}

.overlay-content span {
  display: block;
  font-size: 16px;
}

.price-range-display {
  text-align: center;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.slider {
  margin-top: 10px;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-30px);
  }

  60% {
    transform: translateY(-15px);
  }
}

/* Botón Go */
.go-button {
  background-color: #007bff;
  /* Color de fondo */
  color: white;
  /* Color del texto */
  padding: 12px 20px;
  /* Más padding para hacerlo más grande */
  border: none;
  /* Sin bordes */
  cursor: pointer;
  /* Cursor de puntero */
  font-size: 16px;
  /* Tamaño de fuente más grande */
  border-radius: 8px;
  /* Bordes redondeados */
  width: 100%;
  /* Ocupa todo el ancho del contenedor */
  text-align: center;
  /* Centra el texto */
  transition: background-color 0.3s ease, transform 0.3s ease;
  /* Transición suave */
  margin-top: 10px;
  /* Espacio superior */
}

/* Efecto hover para el botón */
.go-button:hover {
  background-color: #0056b3;
  /* Color más oscuro al pasar el mouse */
  transform: translateY(-2px);
  /* Efecto de elevación */
}

.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  /* Ajusta el tamaño según necesites */
}

.spinner {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  /* Color de la bola */
  border-radius: 50%;
  width: 60px;
  /* Tamaño de la bola */
  height: 60px;
  /* Tamaño de la bola */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.cart-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 2;
}

.cart-button:hover {
  transform: scale(1.1);
  background-color: #3e6af7;
  color: white;
}

.cart-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-controls {
  display: flex;
  gap: 5px;
  background-color: white;
  border-radius: 20px;
  padding: 5px;
  position: absolute;
  top: 10px;
  right: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 2;
}



.quantity-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.quantity {
  font-size: 16px;
  font-weight: bold;
  color: black;
}

.cart-controls {
  cursor: default;
}
</style>
